export default __webpack_public_path__ + "static/media/excel-file.304eabb0.svg";